/**
 * @generated SignedSource<<86d16bf5290fd39503332c45c53ce53d>>
 * @relayHash 5ac4a503ec36ddd73a7f8174807a81e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 79a25957872f6a71ba17d78d38acc59274ea9570d8c579c54d5eee463e0727c7

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TagUpdatesFeedAggQuery$variables = {
  containerId: string;
  shouldFetchUpdatesTabData: boolean;
  tagId: string;
};
export type TagUpdatesFeedAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TagUpdatesFeedAgg">;
};
export type TagUpdatesFeedAggQuery = {
  response: TagUpdatesFeedAggQuery$data;
  variables: TagUpdatesFeedAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchUpdatesTabData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagId"
},
v3 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v4 = {
  "kind": "Variable",
  "name": "tagId",
  "variableName": "tagId"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v6 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v10 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v11 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v15 = {
  "kind": "ScalarField",
  "name": "summary"
},
v16 = {
  "kind": "ScalarField",
  "name": "description"
},
v17 = [
  (v8/*: any*/),
  (v15/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v16/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "url"
},
v19 = {
  "concreteType": "TownsquareUpdateGenerationSettings",
  "kind": "LinkedField",
  "name": "updateGenerationSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "templateKey"
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v21 = {
  "kind": "ScalarField",
  "name": "ari"
},
v22 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v23 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v24 = {
  "kind": "ScalarField",
  "name": "picture"
},
v25 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v26 = {
  "kind": "ScalarField",
  "name": "start"
},
v27 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  {
    "concreteType": "TownsquareTargetDateRange",
    "kind": "LinkedField",
    "name": "dateRange",
    "plural": false,
    "selections": [
      (v26/*: any*/),
      {
        "kind": "ScalarField",
        "name": "end"
      }
    ]
  }
],
v28 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v30 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v25/*: any*/),
    (v13/*: any*/),
    (v8/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v32 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v33 = [
  (v8/*: any*/)
],
v34 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v8/*: any*/),
          (v13/*: any*/),
          (v25/*: any*/),
          (v24/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v33/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v33/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v8/*: any*/)
],
v35 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v27/*: any*/)
},
v36 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v37 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v38 = {
  "kind": "ScalarField",
  "name": "archived"
},
v39 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    }
  ]
},
v40 = [
  (v7/*: any*/),
  (v24/*: any*/),
  (v13/*: any*/),
  (v25/*: any*/),
  (v8/*: any*/)
],
v41 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v42 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            (v16/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isTownsquareHighlight"
            },
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v40/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "lastEditedBy",
              "plural": false,
              "selections": (v40/*: any*/)
            },
            (v31/*: any*/),
            {
              "kind": "ScalarField",
              "name": "lastEditedDate"
            }
          ]
        }
      ]
    },
    (v41/*: any*/)
  ]
},
v43 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v13/*: any*/),
                (v8/*: any*/),
                (v25/*: any*/),
                (v24/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v32/*: any*/),
            (v31/*: any*/)
          ]
        }
      ]
    },
    (v41/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "type"
},
v45 = {
  "kind": "ScalarField",
  "name": "subType"
},
v46 = {
  "kind": "ScalarField",
  "name": "source"
},
v47 = {
  "kind": "ScalarField",
  "name": "time"
},
v48 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v47/*: any*/),
    (v8/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "value"
},
v50 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v51 = {
  "kind": "ScalarField",
  "name": "score"
},
v52 = [
  (v49/*: any*/),
  (v51/*: any*/),
  {
    "concreteType": "TownsquareCompletionGoalState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": [
      (v49/*: any*/),
      (v51/*: any*/)
    ]
  }
],
v53 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v54 = [
  (v49/*: any*/),
  (v47/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TagUpdatesFeedAggQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "shouldFetchUpdatesTabData",
            "variableName": "shouldFetchUpdatesTabData"
          },
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TagUpdatesFeedAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TagUpdatesFeedAggQuery",
    "selections": [
      {
        "condition": "shouldFetchUpdatesTabData",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "TownsquareUpdateConnection",
            "kind": "LinkedField",
            "name": "statusUpdates_byTag",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "watching"
                              },
                              (v9/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchProject"
                                  },
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareIconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "startDate"
                              },
                              {
                                "concreteType": "TownsquareProjectUpdate",
                                "kind": "LinkedField",
                                "name": "latestUserUpdate",
                                "plural": false,
                                "selections": (v17/*: any*/)
                              },
                              (v18/*: any*/),
                              (v19/*: any*/),
                              {
                                "concreteType": "TownsquareProjectCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v13/*: any*/),
                              (v24/*: any*/),
                              (v8/*: any*/),
                              (v25/*: any*/)
                            ]
                          },
                          (v28/*: any*/),
                          {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v29/*: any*/)
                          },
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v34/*: any*/)
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v29/*: any*/)
                          },
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/)
                        ],
                        "type": "TownsquareProjectUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isWatching"
                              },
                              (v9/*: any*/),
                              {
                                "concreteType": "TownsquareGoalCapabilities",
                                "kind": "LinkedField",
                                "name": "capabilities",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                  },
                                  (v10/*: any*/),
                                  (v20/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "parentGoal",
                                "plural": false,
                                "selections": (v33/*: any*/)
                              },
                              (v12/*: any*/),
                              (v13/*: any*/),
                              {
                                "concreteType": "TownsquareGoalIcon",
                                "kind": "LinkedField",
                                "name": "icon",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appearance"
                                  }
                                ]
                              },
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v38/*: any*/),
                                              (v13/*: any*/),
                                              (v44/*: any*/),
                                              (v45/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "externalEntityId"
                                              },
                                              (v46/*: any*/),
                                              (v48/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v26/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v49/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v8/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "startValue"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "targetValue"
                                          },
                                          {
                                            "concreteType": "TownsquareMetricValue",
                                            "kind": "LinkedField",
                                            "name": "snapshotValue",
                                            "plural": false,
                                            "selections": [
                                              (v49/*: any*/),
                                              (v8/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "scoringMode"
                              },
                              {
                                "args": [
                                  (v5/*: any*/)
                                ],
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v17/*: any*/)
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              },
                              (v19/*: any*/),
                              {
                                "concreteType": "TownsquareGoalProgress",
                                "kind": "LinkedField",
                                "name": "progress",
                                "plural": false,
                                "selections": [
                                  (v50/*: any*/),
                                  (v44/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canPostUpdate"
                              },
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canEditUpdate"
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "hasConnectedUpdates"
                          },
                          (v31/*: any*/),
                          (v15/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "newState",
                            "plural": false,
                            "selections": (v52/*: any*/)
                          },
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v39/*: any*/),
                          (v42/*: any*/),
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          (v13/*: any*/),
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          (v38/*: any*/),
                                          (v46/*: any*/),
                                          (v48/*: any*/),
                                          {
                                            "args": [
                                              (v53/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v54/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v54/*: any*/)
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v47/*: any*/),
                                          (v8/*: any*/),
                                          (v49/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v25/*: any*/),
                              (v13/*: any*/),
                              (v24/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          (v28/*: any*/),
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": [
                              (v44/*: any*/),
                              (v50/*: any*/)
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 50
                              }
                            ],
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalProgress",
                                        "kind": "LinkedField",
                                        "name": "progress",
                                        "plural": false,
                                        "selections": [
                                          (v50/*: any*/)
                                        ]
                                      },
                                      (v8/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          },
                          (v30/*: any*/),
                          (v32/*: any*/),
                          {
                            "args": [
                              (v53/*: any*/)
                            ],
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v34/*: any*/)
                              }
                            ],
                            "storageKey": "viewers(first:100)"
                          },
                          (v18/*: any*/),
                          (v43/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v52/*: any*/)
                          },
                          (v35/*: any*/)
                        ],
                        "type": "TownsquareGoalUpdate"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v33/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v6/*: any*/),
            "filters": [
              "tagId",
              "containerId"
            ],
            "handle": "connection",
            "key": "TagUpdatesFeedAgg_statusUpdates_byTag",
            "kind": "LinkedHandle",
            "name": "statusUpdates_byTag"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "79a25957872f6a71ba17d78d38acc59274ea9570d8c579c54d5eee463e0727c7",
    "metadata": {},
    "name": "TagUpdatesFeedAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "574ebd0ce42de226d24c5233c3ba2a9b";

export default node;
